import type { ReactNode } from "react";
import type { LoadState } from "@/components/dataset/loadState";
import { EmptyState } from "@/shared/ui/emptyState/public";
import { LoadingState } from "@/shared/ui/loadingState/public";

/**
 * 조회 상태 네 가지(idle·loading·error·success)를 한 곳에서 그린다.
 *
 * 네 패널이 같은 상태 기계를 쓰므로 각 패널이 분기를 다시 쓰지 않는다. 로딩 중에 직전 데이터를
 * 유지하는 일은 컨트롤러(`useObservabilityMetric`)가 한다. 그래서 여기 오는 `loading` 은 첫 조회뿐이다.
 * 대기와 실패는 탭 본문 전체를 대신한다. 그래서 `lg` 다.
 */
export function ObservabilityStateBlock<T>({
  state,
  loadingText,
  onRetry,
  children,
}: {
  state: LoadState<T>;
  loadingText: string;
  onRetry: () => void;
  children: (data: T) => ReactNode;
}): ReactNode {
  if (state.status === "error") {
    return (
      <EmptyState size="lg" tone="error" action={{ label: "다시 시도", onClick: onRetry }}>
        {state.message}
      </EmptyState>
    );
  }
  if (state.status !== "success") {
    return <LoadingState size="lg">{loadingText}</LoadingState>;
  }
  return children(state.data);
}
